export const management = {
  routes: [
    {
      path: "/management/library/safe-country-map",
      component: () => import("../management-library-safe-country-map-view"),
    },
  ],
};

export const workspace = {
  routes: [
    {
      path: "/workspace/library/safe-country-map",
      component: () => import("../workspace-library-safe-country-map-view"),
    },
  ],
};
